import { render, staticRenderFns } from "./VehicleComponent.vue?vue&type=template&id=ebd17570&"
import script from "./VehicleComponent.vue?vue&type=script&lang=js&"
export * from "./VehicleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports